/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import ManageControls from 'src/components/manage-controls.jsx';
import Button from '#lib/components/button.jsx';
import { validateProfile } from '#lib/helpers/errors.js';

import { toast } from 'react-hot-toast';
import { Icon } from '@iconify-icon/react';

export function ProfileButtons(props) {
    const { selectedProfile, updateItineraryOptions, handleSaveProfile, handleDeleteProfile, setErrors } = props;

    return (
        <ManageControls.ButtonSlot>
            <Button
                title={_t.global.save()}
                onClick={() => {
                    if (!validateProfile(selectedProfile, setErrors)) return toast.error('Validation error');
                    if (selectedProfile.loading) {
                        toast.error(_t.crud.itinerary.waitMediaLoaded());
                        return;
                    }
                    handleSaveProfile(selectedProfile);
                }}
                size="xs"
                busy={updateItineraryOptions.isLoading}
            >
                <span className={'w-full flex justify-center'}>
                    <Icon
                        icon="material-symbols:save-outline-rounded"
                        width="1.2rem"
                        height="1.2rem"
                        className="mr-1"
                    />
                    {_t.global.save()}
                </span>
            </Button>
            <Button
                title={_t.global.delete()}
                onClick={() => {
                    if (selectedProfile.loading) {
                        toast.error(_t.crud.itinerary.waitMediaLoaded());
                        return;
                    }
                    const confirm = window.confirm(_t.global.confirmDelete());
                    if (!confirm) return;
                    handleDeleteProfile(selectedProfile);
                }}
                size="xs"
            >
                <span className="w-full flex justify-center text-red-700">
                    <Icon icon="ph:trash" width="1.2rem" height="1.2rem" className="mr-1" />
                    {_t.global.delete()}
                </span>
            </Button>
        </ManageControls.ButtonSlot>
    );
}
